import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  templateUrl: './licenses.component.html',
  standalone: false,
})
export class LicensesComponent {
  constructor(public dialogRef: MatDialogRef<LicensesComponent>) {}
}
